export enum ApiRoutesAiConversations {
  Conversations = "admin/whatsapp-bot/conversations"
}

export enum AiConversationSubRoute {
  Messages = "messages",
  Takeover = "takeover",
  Release = "release",
  MarkRead = "mark-read",
  Mode = "mode",
  Turns = "turns"
}

// Who produced an AI row: the model's own reply, a fixed sentence written by
// the code, or a card/media a tool sent. Rows written before the column
// existed come back null ("unknown origin").
export enum WhatsAppMessageOrigin {
  Model = "model",
  System = "system",
  Tool = "tool"
}

export enum WhatsAppConversationStatus {
  Ai = "ai",
  Human = "human",
  Closed = "closed"
}

export enum WhatsAppMessageDirection {
  Inbound = "inbound",
  Outbound = "outbound"
}

export enum WhatsAppMessageSender {
  Customer = "customer",
  Ai = "ai",
  Admin = "admin"
}

export enum WhatsAppMessageStatus {
  Received = "received",
  Sent = "sent",
  Delivered = "delivered",
  Read = "read",
  Failed = "failed"
}

export enum WhatsAppMessageType {
  Text = "text",
  Image = "image",
  Voice = "voice",
  Document = "document",
  Video = "video",
  TemplateCarousel = "template_carousel",
  ProductCard = "product_card",
  PackCard = "pack_card"
}

export const AI_CONVERSATIONS_QUERY_KEY = "ai-conversations";
